import { authOidcDebugLog } from '@/auth/authOidcDebugLog'

/**
 * Centralize the reaction to the inability to silently renew the OIDC session
 * (refresh token / SSO Keycloak expired). Registered by AuthProvider (toast + navigation).
 */
let handler: (() => void | Promise<void>) | null = null
let lastNotifyMs = 0
const DEBOUNCE_MS = 4000

export function registerAuthSessionLostHandler(
  fn: () => void | Promise<void>
): () => void {
  handler = fn
  return () => {
    handler = null
  }
}

export function notifyAuthSessionLost(
  reason: string,
  extra?: Record<string, unknown>
): void {
  const now = Date.now()
  if (!handler) {
    authOidcDebugLog('session_lost_skipped_no_handler', {
      reason,
      ...extra,
    })
    return
  }
  if (now - lastNotifyMs < DEBOUNCE_MS) {
    authOidcDebugLog('session_lost_debounced', {
      reason,
      msSinceLastNotify: now - lastNotifyMs,
      debounceMs: DEBOUNCE_MS,
      ...extra,
    })
    return
  }
  lastNotifyMs = now
  authOidcDebugLog('session_lost_firing', { reason, ...extra })
  const run = handler
  // Defer outside React / Apollo cycle (avoids conflicts with effect cleanups, e.g. after signinSilent).
  setTimeout(() => {
    void Promise.resolve(run())
  }, 0)
}
